import { Vue , Component , Prop} from 'vue-property-decorator';

@Component({ name: 'ed-image-created' })
export default class EdCalendar extends Vue {

  /* Props */
  @Prop() readonly image: any;
  @Prop() readonly onRemoveImg: string;
  @Prop({default: false}) readonly isSaving: boolean;

  /* Computed */
  get background() {
    let img = this.image.thumbnailMediumUrl ? this.image.thumbnailMediumUrl : this.image.url;
    return {'background-image': `url(${img})`};
  }

  /* Methods */
  public removeImg() {
    this.$emit('onRemoveImg', this.image);
  }
}